import { createAction } from '@reduxjs/toolkit'

import { SIM } from 'redux/reducers/DataPlatform/SIM'

export const activateStandard = createAction('activate_standard')
export const activateStandardSuccess = createAction<SIM>(
  'activate_standard_success'
)
export const activateStandardFailed = createAction('activate_standard_failed')
